import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import { Box, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useHistory } from "react-router-dom";
import { GetSettlementRequestDetailByKeyResponse } from "../../models/settlement.model";
import {
  GetPaymentSettlementZipFile,
  getSettlementRequestDetailByKey,
} from "../../services/settlement.service";
import SupplierSettelmentRequestDetailHeader from "./components/SupplierSettelmentRequestDetailHeader";
import SupplierSettelmentRequestDetailTable from "./components/SupplierSettelmentRequestDetailTable";

const SettlementHistoryDetail = () => {
  const [requestDetail, setRequestDetail] = useState<
    GetSettlementRequestDetailByKeyResponse
  >();
  const history = useHistory<{
    settlementData?: {
      saleKey?: string;
      key?: string;
      branchId: number;
      customerPersonId: number;
    };
  }>();
  const settlementData =
    history?.location?.state?.settlementData !== undefined
      ? history?.location?.state?.settlementData
      : JSON.parse(
          window.localStorage.getItem("SETTLEMENT_REQUEST_DATA") || "{}"
        );

  const key = settlementData.key;
  const handleClick = (
    key: string,
    branchId: number,
    customerPersonId: number
  ) => {
    const newWindow = window.open("/#/StoreRequestDetail", "_blank");
    newWindow?.sessionStorage.setItem(
      "SETTLEMENT_REQUEST_DATA",
      JSON.stringify({
        ...settlementData,
        saleKey: key,
        branchId,
        customerPersonId,
      })
    );
    newWindow?.history.pushState(
      {
        settlementData: {
          ...settlementData,
          saleKey: key,
          branchId,
          customerPersonId,
        },
      },
      "",
      "/StoreRequestDetail"
    );
  };
  const { mutate: getSettlementRequestDetailByKeyMutate } = useMutation(
    getSettlementRequestDetailByKey,
    {
      onSuccess: (data: GetSettlementRequestDetailByKeyResponse) => {
        if (data) {
          setRequestDetail(data);
        }
      },
      onError: () => {},
    }
  );
  const { mutate: GetPaymentSettlementZipFileMutate } = useMutation(
    GetPaymentSettlementZipFile,
    {
      onSuccess: (data: any) => {
        if (data) {
        }
      },
      onError: () => {},
    }
  );
  const handleDownloadDocs = () => {
    GetPaymentSettlementZipFileMutate({ key: key });
  };

  const handleRefresh = () => {
    getSettlementRequestDetailByKeyMutate({
      key: key!,
    });
  };

  useEffect(() => {
    getSettlementRequestDetailByKeyMutate({
      key: key!,
    });
  }, [key]);

  return (
    <Grid container gap={"20px"} height={"fit-content"}>
      {key && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            paddingInline: "10px",
          }}
        >
          <RefreshIcon
            onClick={handleRefresh}
            className='colorTitle iconStyle cursorPointer'
          />
          <Typography
            sx={{
              color: "#1D4A87",
              cursor: "pointer",
              width: "fit-content",
            }}
            onClick={handleDownloadDocs}
          >
            <FileDownloadOutlinedIcon
              sx={{ fontSize: "1.5rem", marginLeft: "3px" }}
            />
            دانلود مستندات
          </Typography>
        </Box>
      )}
      <Grid item xs={12} height={"20%"}>
        <SupplierSettelmentRequestDetailHeader
          creatorName={requestDetail?.creatorName || ""}
          createDate={requestDetail?.createDate || ""}
          createDatePersian={requestDetail?.createDatePersian || ""}
          creatorDescription={requestDetail?.creatorDescription || ""}
          settlementTypeTitle={requestDetail?.settlementTypeTitle || ""}
          settlementAmount={requestDetail?.settlementAmount || 0}
          factorAmount={requestDetail?.factorAmount || 0}
          confirmerName={requestDetail?.confirmerName || ""}
          confirmDate={requestDetail?.confirmDate || ""}
          confirmDatePersian={requestDetail?.confirmDatePersian || ""}
          confirmerDescription={requestDetail?.confirmerDescription || ""}
          sayadNumber={requestDetail?.sayadNumber || ""}
          chequeSeri={requestDetail?.chequeSeri || ""}
          chequeSerial={requestDetail?.chequeSerial || ""}
          chequeDueDate={requestDetail?.chequeDueDate || ""}
          chequeDueDatePersian={requestDetail?.chequeDueDatePersian || ""}
          settlementType={requestDetail?.settlementType!}
          key={requestDetail?.key!}
        />
      </Grid>
      <Grid item xs={12} height={"45vh"}>
        <SupplierSettelmentRequestDetailTable
          count={requestDetail?.sales?.length || 0}
          sales={requestDetail?.sales || []}
          handleRowClick={handleClick}
        />
      </Grid>
    </Grid>
  );
};

export default SettlementHistoryDetail;
